
import Modal from 'react-modal';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { changeLayerList, deleteLayerForce } from '../../../../store/tool';
import { setLayerModalLayers, setLayerModalOpen } from '../../../../store/interaction';
import LayerList from './LayerList';
import "./LayerSettingsModal.css"
import { deleteShapesFromLayer, moveFromOneLayerToAnother } from '../../../../store/model';
import LayersIcon from "../../../pictures/modal_pictures/2D_editor_icon_layer_w_20x20.png"
import LayerModalHeader from './LayerModalHeader';
import LayerModalExitOptions from './LayerModalExitOptions';
import { RootState } from "../../../../store/store";

const LayerSettingsModal = () => {
  const dispatch = useAppDispatch();
  const layerEditorState = useAppSelector((state: RootState) => state.interaction.layerEditorModal)
  const layerList = useAppSelector((state: RootState) => state.tool.layerList)

  function afterOpenModal() {
    console.log("open",layerList);
    
    dispatch(setLayerModalLayers(layerList))
  }
  function closeModalWithOk() {
    dispatch(setLayerModalOpen(false))

    layerEditorState.deleteLayerAndMoveToIds.forEach(m => {
      dispatch(moveFromOneLayerToAnother({ deleteId: m.from, moveToId: m.to }))
      dispatch(deleteLayerForce({ deleteId: m.from }))
    })
    layerEditorState.deleteLayerAndContentId.forEach(m => {
      dispatch(deleteShapesFromLayer({ deleteLayerId: m }))
      dispatch(deleteLayerForce({ deleteId: m }))
    })


    dispatch(changeLayerList(layerEditorState.layerList))
    //dispatch(setLayerModalLayers(layerList))
  }
  function closeModalWithCancel() {
    dispatch(setLayerModalOpen(false))
    //dispatch(setLayerModalLayers(layerList))
  }
  Modal.setAppElement('#root');

  return (
    <Modal
      overlayClassName={"layerModal__Overlay"}
      className="layerModal"
      isOpen={layerEditorState.open}
      onAfterOpen={afterOpenModal}
      //onRequestClose={closeModal}
      shouldCloseOnOverlayClick={true}
      contentLabel="Layers"
    >
      <LayerModalHeader icon={LayersIcon} title={"Layers"} closeAction={closeModalWithCancel} />
      <LayerList
        temporaryLayerList={layerEditorState.layerList}
        setTemporaryLayerList={(l) => { dispatch(setLayerModalLayers(l)) }}
      />
      <LayerModalExitOptions
        okAction={closeModalWithOk}
        cancelAction={closeModalWithCancel}
      />
    </Modal>

  )
}

export default LayerSettingsModal